<label class="tw-text-l1 tw-text-color-1">{{label}}
    <div class="tw-text-danger tw-inline-block tw-relative tw-align-baseline tw-top-[-9px]" *ngIf="required">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
            <path
                d="M1.43673 7.99951L4.11428 6.07298L6.79184 7.99951L5.77959 4.93013L8.22857 3.26482H5.19184L4.11428 -0.000488281L3.03673 3.26482H0L2.44898 4.93013L1.43673 7.99951Z"
                fill="#E51919" />
        </svg>
    </div>
</label>